import {  Box} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../../components/Header";
import ImageInput from "../../../components/imageInput";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  addExtra,
  getExtraError,
  getExtraStatus,
  getExtraSuccess,
  getExtraLoading,
  updateStatus,
} from "../../../features/extraSlice";
import { useNavigate } from "react-router-dom";
import TextFieldCompnent from "../../../components/textFieldComponent";
import RadioButtonComponent from "../../../components/radioButtonComponent";
import { useRestaurant } from "../../../hooks/RestaurantContext";
import { getImageFormFields } from "../../../global/functions/imageHelper";
import ButtonComponent from "../../../components/ButtonComponent";
import { useTranslation } from "react-i18next";

const AddExtra = () => {
  const { t } = useTranslation();
  const { restaurantId } = useRestaurant();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [previewImage, setPreviewImage] = useState(null);
  const dispatch = useDispatch();
  const status = useSelector(getExtraStatus);
  const error = useSelector(getExtraError);
  const loading = useSelector(getExtraLoading);
  const success = useSelector(getExtraSuccess);
  const navigate = useNavigate();

  const extraSchema = yup.object().shape({
    name: yup.string().required("Nom est requis"),
    price: yup
      .number()
      .required("Le prix est requis")
      .min(0, "La prix minimal est 0"),
    outOfStock: yup.boolean(),
    visible: yup.boolean(),
  });
  const initialValues = {
    name: "",
    image: "",
    price: 0,
    outOfStock: false,
    visible: true,
  };
  const handleFormSubmit = (values) => {
    dispatch(
      addExtra({
        body: {
          name: values.name,
          ...getImageFormFields(previewImage),
          price: values.price,
          outOfStock: values.outOfStock,
          visible: values.visible,
        },
        restaurantId,
      })
    );
  };
  useEffect(() => {
    if (status === "addSuccess") {
      toast.success(success);
      dispatch(updateStatus());
      navigate("/extra");
    } else if (status === "addError") {
      toast.error(error);
    }
  }, [status, error, dispatch, navigate, success]);

  return (
    <Box m="20px" className="main-application">
      <Header title={t("headers.addExtra")} subtitle={t("headers.addExtraSub")} />
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={extraSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="16px"
              gridTemplateColumns="repeat(6, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 6" },
              }}
            >
              <TextFieldCompnent
                type="text"
                label={t("fields.name")}
                change={handleChange}
                value={values.name}
                name="name"
                blur={handleBlur}
                touched={touched.name}
                error={errors.name}
                colum="span 3"
                row="1 / span 1"
                required
              />
              <TextFieldCompnent
                type="number"
                label={t("fields.price")}
                change={handleChange}
                value={values.price || 0}
                name="price"
                blur={handleBlur}
                touched={touched.price}
                error={errors.price}
                colum="span 3"
                row="2 / span 1"
                num={0}
                required
              />
              <RadioButtonComponent
                change={handleChange}
                colum="span 3"
                row="3 / span 1"
                name="outOfStock"
                radioText1={t("common.no")}
                radioText2={t("common.yes")}
                radioValue1={false}
                radioValue2={true}
                text={t("fields.outOfStock")}
                value={values.outOfStock}
              />
              <RadioButtonComponent
                change={handleChange}
                colum="span 3"
                row="4 / span 1"
                name="visible"
                radioText1={t("common.no")}
                radioText2={t("common.yes")}
                radioValue1={false}
                radioValue2={true}
                text={t("fields.showItem")}
                value={values.visible}
              />
              <ImageInput
                row="5 / span 1"
                previewImage={previewImage}
                setPreviewImage={setPreviewImage}
              />
            </Box>
            <ButtonComponent text={t("common.submit")} loading={loading} />
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default AddExtra;
